var _circle, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeLearningMaterial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 75,
    fill: "#EDF1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 55C20.4772 55 16 59.4772 16 65V128C16 133.523 20.4772 138 26 138H67.0891L76.0331 143.309C77.5865 144.231 81.4627 144.23 83.0103 143.307L91.9055 138H133C138.523 138 143 133.523 143 128V65C143 59.4772 138.523 55 133 55H26Z",
    fill: "#4F75FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 49.9409C26 48.1913 27.1327 46.6486 28.8178 46.178C33.8999 44.759 44.8309 42 53 42C63.9973 42 80 47 80 47V129C80 129 63.9973 124 53 124C45.9569 124 36.8607 126.051 31.23 127.526C28.6196 128.209 26 126.258 26 123.56V49.9409Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47C80 47 96.0027 42 107 42C115.169 42 126.1 44.759 131.182 46.178C132.867 46.6486 134 48.1913 134 49.9409V123.56C134 126.258 131.38 128.209 128.77 127.526C123.139 126.051 114.043 124 107 124C96.0027 124 80 129 80 129V47Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 78,
    width: 30,
    height: 5,
    rx: 2.5,
    fill: "#C5CCFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 67,
    width: 6,
    height: 5,
    rx: 2.5,
    fill: "#C5CCFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 89,
    width: 30,
    height: 5,
    rx: 2.5,
    fill: "#C5CCFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 100,
    width: 30,
    height: 5,
    rx: 2.5,
    fill: "#C5CCFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 111,
    width: 30,
    height: 5,
    rx: 2.5,
    fill: "#C5CCFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 5,
    rx: 2.5,
    transform: "matrix(-1 0 0 1 47 56)",
    fill: "#C5CCFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 67,
    width: 6,
    height: 5,
    rx: 2.5,
    fill: "#C5CCFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 5,
    rx: 2.5,
    transform: "matrix(-1 0 0 1 123 78)",
    fill: "#C5CCFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 5,
    rx: 2.5,
    transform: "matrix(-1 0 0 1 123 89)",
    fill: "#C5CCFF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 5,
    rx: 2.5,
    transform: "matrix(-1 0 0 1 123 56)",
    fill: "#C5CCFF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 5,
    rx: 2.5,
    transform: "matrix(-1 0 0 1 123 100)",
    fill: "#C5CCFF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 5,
    rx: 2.5,
    transform: "matrix(-1 0 0 1 123 111)",
    fill: "#C5CCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLearningMaterial);
export default __webpack_public_path__ + "static/media/home_learning_material.c3fc224c37eec36ed91575e9372c048c.svg";
export { ForwardRef as ReactComponent };